exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rule-modal[data-v-2e9d3092] {\n  padding-right: 0 !important;\n}", ""]);

// exports
